module.exports = __webpack_public_path__ + "media/images/gallery-image6-681447c54ac7ecfad5025af7f3baf0b2.webp";